import { render, staticRenderFns } from "./ObjectsAutoComplete.vue?vue&type=template&id=08a81944&scoped=true"
import script from "./ObjectsAutoComplete.vue?vue&type=script&lang=js"
export * from "./ObjectsAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a81944",
  null
  
)

export default component.exports